import Home from "./home";
import Order from "./Order";
import More from "./more";

export const Pages = {
  Home,
  Order,
  More
}